import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppConstants } from '@wz-constants';
@Component({
  selector: 'wz-header-afi',
  templateUrl: './header-afi.component.html',
  styleUrls: ['./header-afi.component.scss'],
  standalone: false,
})
export class HeaderAfiComponent implements OnInit, AfterViewInit {
  navbarOpened = false;
  number_phone = '01 87 52 78 79';
  isnps = false;
  quotationParamOrigin = null;

  constructor() {}

  ngAfterViewInit(): void {
    this.setNumberSite();
  }

  ngOnInit() {
    if (
      window.location.href.split('/')[3].includes('donnez-votre-avis') ||
      window.location.href.split('/')[3].includes('donnez-votre-avis-client') ||
      window.location.href.split('/')[3] === 'oops' ||
      window.location.href.split('/')[3] === 'remerciements' ||
      window.location.href.split('/')[3].includes('opinion-assurance')
    )
      this.isnps = true;

    this.setNumberSite();
  }

  setNumberSite() {
    let paramOrigin = localStorage.getItem('paramOrigin');
    this.quotationParamOrigin = null;
    if (!paramOrigin) {
      this.number_phone = AppConstants.SiteNumber.NUMBER;
    } else {
      this.number_phone = AppConstants.SiteNumber.NUMBER_FRNACHISE;
    }
  }

  toggleMobileMenu() {
    this.navbarOpened = !this.navbarOpened;
  }
}
